import React, { useEffect } from "react";
import { Drawer, Form, Input, Button, Space, Row, Col, Divider, InputNumber } from "antd";

const CmpyAddEdit = ({ open, onClose, onSubmit, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue(initialValues || {});
    }
  }, [open, initialValues, form]);

  const handleFinish = (values) => {
    onSubmit(values);
    form.resetFields();
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Drawer
      title={initialValues ? "Edit Company Location" : "Add Company Location"}
      width={600}
      onClose={handleClose}
      open={open}
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleFinish}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Company Name"
              rules={[{ required: true }]}
            >
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="phone" label="Phone">
              <InputNumber
                size="large"
                style={{ width: "100%" }}
                controls={false}
              />
            </Form.Item>

          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="mail"
              label="Email"
              rules={[
                { type: "email", message: "Please enter a valid email!" },
                { required: true, message: "Email is required!" },
              ]}
            >
              <Input size="large" />
            </Form.Item>

          </Col>
          <Col span={12}>
            <Form.Item name="website" label="Website">
              <Input size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="address_1" label="Address Line 1">
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="address_2" label="Address Line 2">
              <Input size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="pincode"
              label="Pincode"
              rules={[
                { required: true, message: "Required!" },
              ]}
            >
              <Input size="large" maxLength={10} />
            </Form.Item>

          </Col>
          <Col span={12}>
            <Form.Item
              name="state"
              label="State"
              rules={[
                { required: true, message: "Required!" }
              ]}
            >
              <Input size="large" />
            </Form.Item>

          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="country" label="Country">
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="note" label="Note">
              <Input.TextArea rows={3} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px'
        }}>
          <Button size="large" onClick={onClose}>Cancel</Button>
          <Button size="large" type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </Form>
    </Drawer>
  );
};

export default CmpyAddEdit;